// Shared ajax loader used by the prematch page.

global.ajaxLoad = function(url, success, complete) {
  $.ajax(url, {
    method: 'GET',
    success: success,
    error: function(e) {
      console.log('load error for ' + url, e);
    },
    complete: complete
  });
};
